import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CheckboxIcon from '../../../../../../../components/icons/CheckboxIcon';

const propTypes = {
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

const AddedToCartLabel = ({ label = 'Added to cart!' }) => {
  return (
    <Fragment>
      <span className="d-block">{label}</span>
      <CheckboxIcon className="btn-purchase-options-in-cart-check" />
    </Fragment>
  );
};

AddedToCartLabel.propTypes = propTypes;

export default AddedToCartLabel;
